import { useState } from 'react'
import { BrowserRouter, Routes, Route, Outlet } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import './Components.css'
import './Pages.css'
/* Components */
import Footer from './Components/Footer'
import ScrollToTopButton from './Components/ScrollButton'
import LaunchModal from './Components/LaunchModal'

/* Pages */
import Homepage from './Pages/Homepage'
import FormOrcamento from './Pages/FormsOrcamento'
import FormsContact from './Pages/FormsContact'
import Atendimento from './Pages/Atendimento'
import Clinicas from './Pages/Clinicas'
import NotFoundPage from './Pages/NotFound'
import Header from './Components/Header'

function App() {
  const [openLaunchModal, setOpenLaunchModal] = useState(true)

  return (
    <>
      <BrowserRouter>
        <LaunchModal
          open={openLaunchModal}
          onClose={() => setOpenLaunchModal(false)}
        />
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <main className="app-main">
                <Outlet />
              </main>
            }
          >
            <Route path="/" exact element={<Homepage />} />
            <Route path="/atendimento" element={<Atendimento />} />
            <Route path="/orcamento" element={<FormOrcamento />} />
            <Route path="/contato" element={<FormsContact />} />
            <Route path="/clinicas" element={<Clinicas />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
        <ScrollToTopButton />
        <Footer />
      </BrowserRouter>
    </>
  )
}

export default App
